import React, { useState } from 'react';
import {
  Container,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  Button,
} from 'reactstrap';
import Modal from '../Common/Modal/Modal';
import CreateExtraCalls from './CreateExtraCalls';

import { useTranslation } from 'react-i18next';

const BatchCallBar = ({ calls, selectedCallIds, users }) => {
  const [createExtraCallsModal, setCreateExtraCallsModal] = useState(false);

  calls = calls.filter(({ id }) => selectedCallIds.includes(id));
  const { t } = useTranslation();

  return (
    <>
      <div
        className={`fixed-bottom ${
          selectedCallIds.length ? 'visible' : 'invisible'
        }`}>
        <Navbar style={{ backgroundColor: '#2a3042' }} dark expand="md">
          <Container style={{ justifyContent: 'flex-start' }}>
            <NavbarBrand>{t('Manage')}:</NavbarBrand>
            <Nav pills>
              <NavItem>
                <Button
                  color="warning"
                  outline
                  className="waves-effect waves-light"
                  onClick={() => setCreateExtraCallsModal(true)}>
                  <i className="bx bx-phone-call font-size-20 align-middle mr-2"></i>
                  {t('Create Extra Calls')}
                </Button>
              </NavItem>
            </Nav>
          </Container>
        </Navbar>
      </div>
      <Modal
        size="xl"
        title="Create Extra Calls"
        isOpen={createExtraCallsModal}
        toggle={() => setCreateExtraCallsModal(!createExtraCallsModal)}
        showClose
        scrollable={false}>
        <CreateExtraCalls prevCalls={calls} users={users} />
      </Modal>
    </>
  );
};

export default BatchCallBar;
